import { LegalLayout } from "@/components/LegalLayout";

const sections = [
  {
    h: "1. Overview",
    p: [
      "Swishr Central is provided on a subscription basis. This Refund Policy explains when you are entitled to a refund and how to request one. It should be read together with our Terms & Conditions.",
      "In this policy, \u201cwe\u201d, \u201cus\u201d and \u201cour\u201d means Swishr Digital Ltd, a company registered in England and Wales under company number 17391541, with its registered office at Flat 6 Logan House, 1 Logan Place, London, United Kingdom, W8 6QN.",
    ],
  },
  {
    h: "2. Free trial",
    p: [
      "Where we offer a free trial, you can use the relevant features during the trial period at no cost. We will not charge you until the trial ends. You can cancel at any time before the trial ends to avoid being charged.",
    ],
  },
  {
    h: "3. Billing",
    p: [
      "Paid plans are billed in advance on a recurring basis \u2014 monthly or annually, depending on the plan you choose. Your subscription renews automatically at the end of each billing period unless you cancel beforehand.",
    ],
  },
  {
    h: "4. Cancelling your subscription",
    p: [
      "You can cancel your subscription at any time from your account settings or by contacting us. When you cancel, you will continue to have access until the end of your current paid billing period, and you will not be charged again after that.",
    ],
  },
  {
    h: "5. 14-day cancellation right (consumers)",
    p: [
      "If you are a consumer in the UK, you have a statutory right under the Consumer Contracts Regulations 2013 to cancel within 14 days of starting a paid subscription for a full refund \u2014 unless you have asked us to begin, and we have fully supplied, the service within that period, in which case your right to cancel may be lost or a proportionate charge may apply.",
      "This statutory right does not generally apply to business customers; business subscriptions are governed by the refund terms set out below and in our Terms & Conditions.",
    ],
  },
  {
    h: "6. Refunds outside the cancellation period",
    p: [
      "Outside the 14-day consumer cancellation right, subscription fees are generally non-refundable, and we do not provide pro-rata refunds for partial billing periods or for time not used.",
      "We may, at our discretion, offer a refund or credit in exceptional circumstances \u2014 for example, a prolonged service outage that is our fault, or a duplicate or clearly erroneous charge.",
    ],
  },
  {
    h: "7. How to request a refund",
    p: [
      "To request a refund, contact us in writing at our registered office (below) quoting the email address on your account and details of your request. We aim to acknowledge refund requests within 5 business days and, where a refund is approved, to process it within 14 days to your original payment method.",
    ],
  },
  {
    h: "8. Chargebacks",
    p: [
      "If you believe a charge is incorrect, please contact us first so we can resolve it quickly. Raising a chargeback without contacting us may result in your account being suspended while the matter is investigated.",
    ],
  },
  {
    h: "9. Price changes",
    p: [
      "We may change our prices from time to time. Any change will apply from your next billing period, and we will give you reasonable notice. If you do not agree to a price change, you may cancel before it takes effect.",
    ],
  },
  {
    h: "10. Contact us",
    p: ["Questions about this Refund Policy can be sent by post to our registered office: Flat 6 Logan House, 1 Logan Place, London, United Kingdom, W8 6QN."],
  },
];

export default function RefundPolicy() {
  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund Policy"
      updated="6 August 2026"
      intro="This Refund Policy explains how subscriptions, trials, cancellations and refunds work for Swishr Central."
      sections={sections}
    />
  );
}
